import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { catchError, from, Observable, of, switchMap } from 'rxjs';

import { environment } from '@app/environments/environment';
import { LANGUAGE_CODE } from '@app/shared/models/localization-lang';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  public getTranslation(lang: string): Observable<Record<string, string>> {
    if (lang === LANGUAGE_CODE.TESTING_LANGUAGE_CODE) {
      return of({});
    }
    return this.http.get(`${environment.translatesS3Link}/translate_fe/${lang}`, { responseType: 'blob' }).pipe(
      switchMap(response => {
        const ds = new DecompressionStream('gzip');
        const decompressedStream = response.stream().pipeThrough(ds);
        return from(new Response(decompressedStream).json());
      }),
      catchError(() => {
        return this.http.get<Record<string, string>>(`${environment.translatesUrl}?locale=${lang}&category=frontend`);
      }),
    );
  }
}
